/**
 * Офисы для регистрации (пока хардкод, как тарифы)
 */
export type RegistrationOfficeNameKey = 'officeBrussels' | 'officeFlanders';

export interface RegistrationOffice {
    id: number;
    /** Ключ перевода в `t.registration.form` */
    nameKey: RegistrationOfficeNameKey;
    address: string;
}

export const REGISTRATION_OFFICES: readonly RegistrationOffice[] = [
    {
        id: 1,
        nameKey: 'officeBrussels',
        address: '14 Rue de Grand-Bigard, Brussels, Brussels, BE, 1082',
    },
    {
        id: 2,
        nameKey: 'officeFlanders',
        address: '18A Brusselsesteenweg, Asse, Flanders, BE, 1730',
    },
];

/**
 * Получить тариф по ID
 */
export const getOfficeById = (officeId: string): RegistrationOffice | undefined => {
    return REGISTRATION_OFFICES.find((o) => String(o.id) === officeId);
};

export function resolveRegistrationOfficeId(officeFromApi?: number | null): {
    id: string;
    isDefaultValue: boolean;
} {
    const defaultId = String(REGISTRATION_OFFICES[0].id);
    if (officeFromApi == null || officeFromApi === 0) {
        return { id: defaultId, isDefaultValue: true };
    }
    const n = Number(officeFromApi);
    if (Number.isNaN(n) || !REGISTRATION_OFFICES.some((o) => o.id === n)) {
        return { id: defaultId, isDefaultValue: true };
    }
    return { id: String(n), isDefaultValue: false };
}
